import Icon from '@rio-cloud/rio-uikit/Icon';
import SimpleTooltip from '@rio-cloud/rio-uikit/SimpleTooltip';
import { FormattedMessage } from 'react-intl';

import { type CreationFlow, CreationFlows } from '../domain/model/rental-companies.types';

type PartnerCreationFlowIconProps = {
    creationFlow: CreationFlow;
    placement?: 'top' | 'bottom';
    className?: string;
};

const creationFlowIconConfig = {
    [CreationFlows.INVITATION_FLOW]: {
        icon: 'handshake',
        messageId: 'intl-msg:rental-web.dialog.start-rental.partner-creation-invitation-flow.description',
    },
    [CreationFlows.ACCOUNT_ID_FLOW]: {
        icon: 'user-ok',
        messageId: 'intl-msg:rental-web.dialog.start-rental.partner-creation-account-id-flow.description',
    },
} as const;

export const PartnerCreationFlowIcon = ({
    creationFlow,
    placement = 'top',
    className = 'display-inline-block',
}: PartnerCreationFlowIconProps) => {
    const { icon, messageId } = creationFlowIconConfig[creationFlow];

    return (
        <SimpleTooltip content={<FormattedMessage id={messageId} />} placement={placement}>
            <span className={className}>
                <Icon iconName={icon} />
            </span>
        </SimpleTooltip>
    );
};
